<template>
  <div class="remote-mark-container">
    <h1>去除红笔批改痕迹</h1>

    <!-- 上传区域 -->
    <div class="upload-section">
      <el-upload
        class="upload-demo"
        drag
        action="#"
        :auto-upload="false"
        :on-change="handleFileChange"
        :file-list="fileList"
        :limit="1"
        accept="image/*"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件</div>
      </el-upload>

      <div class="upload-actions" v-if="fileList.length > 0">
        <el-button type="primary" @click="handleProcess" :loading="processing">
          开始处理
        </el-button>
        <el-button @click="clearFile">清除文件</el-button>
      </div>
    </div>

    <!-- 处理结果展示区域 -->
    <div class="result-section" v-if="processedImageUrl">
      <div class="image-comparison">
        <div class="image-container">
          <h3>原始图片</h3>
          <img :src="originalImageUrl" alt="原始图片" />
        </div>
        <div class="image-container">
          <h3>处理后图片</h3>
          <img :src="processedImageUrl" alt="处理后图片" />
        </div>
      </div>

      <div class="result-actions">
        <el-button type="success" @click="downloadImage">
          <i class="el-icon-download"></i> 下载处理后的图片
        </el-button>
      </div>
    </div>

    <!-- 处理进度对话框 -->
    <el-dialog
      title="处理中"
      :visible.sync="processingDialogVisible"
      width="30%"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="processing-content">
        <el-progress :percentage="processingProgress" :status="processingStatus"></el-progress>
        <p class="processing-text">{{ processingText }}</p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { removeMarks } from '@/api/ai';

export default {
  name: 'RemoteMark',
  data() {
    return {
      fileList: [],
      processing: false,
      processingDialogVisible: false,
      processingProgress: 0,
      processingStatus: '',
      processingText: '正在处理图片...',
      originalImageUrl: '',
      processedImageUrl: ''
    };
  },
  methods: {
    // 处理文件变化
    handleFileChange(file) {
      this.fileList = [file];
      this.originalImageUrl = URL.createObjectURL(file.raw);
      this.processedImageUrl = ''; // 清除之前的处理结果
    },

    // 清除文件
    clearFile() {
      this.fileList = [];
      this.originalImageUrl = '';
      this.processedImageUrl = '';
    },

    // 处理图片
    async handleProcess() {
      if (!this.fileList.length) {
        this.$message.warning('请先上传图片');
        return;
      }

      this.processing = true;
      this.processingDialogVisible = true;
      this.processingProgress = 0;
      this.processingStatus = '';
      this.processingText = '正在处理图片...';

      try {
        // 模拟进度
        const progressInterval = setInterval(() => {
          if (this.processingProgress < 90) {
            this.processingProgress += 10;
          }
        }, 500);

        // 调用API处理图片
        const result = await removeMarks(this.fileList[0].raw);

        clearInterval(progressInterval);
        this.processingProgress = 100;
        this.processingStatus = 'success';
        this.processingText = '处理完成！';

        // 设置处理后的图片URL
        this.processedImageUrl = result.data;

        this.$message.success('图片处理成功');
      } catch (error) {
        console.error('处理失败:', error);
        this.processingStatus = 'exception';
        this.processingText = '处理失败，请重试';
        this.$message.error('图片处理失败，请重试');
      } finally {
        this.processing = false;
        setTimeout(() => {
          this.processingDialogVisible = false;
        }, 1000);
      }
    },

    // 下载处理后的图片
    downloadImage() {
      if (!this.processedImageUrl) {
        this.$message.warning('没有可下载的图片');
        return;
      }

      const link = document.createElement('a');
      link.href = this.processedImageUrl;
      link.download = `processed_${this.fileList[0].name}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
};
</script>

<style scoped>
.remote-mark-container {
  padding: 30px;
  max-width: 1200px;
  margin: 0 auto;
}

h1 {
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}

.upload-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  margin-bottom: 30px;
}

.upload-actions {
  margin-top: 20px;
  text-align: center;
}

.result-section {
  background: #fff;
  padding: 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.image-comparison {
  display: flex;
  gap: 30px;
  margin-bottom: 30px;
}

.image-container {
  flex: 1;
  text-align: center;
}

.image-container h3 {
  margin-bottom: 15px;
  color: #303133;
}

.image-container img {
  max-width: 100%;
  max-height: 500px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.result-actions {
  text-align: center;
}

.processing-content {
  text-align: center;
  padding: 20px;
}

.processing-text {
  margin-top: 15px;
  color: #606266;
}

.upload-demo {
  width: 100%;
}

.el-upload-dragger {
  width: 100%;
}

@media (max-width: 768px) {
  .image-comparison {
    flex-direction: column;
  }

  .image-container {
    margin-bottom: 20px;
  }
}
</style>
